import {AfterViewInit, ChangeDetectorRef, Directive, ElementRef} from '@angular/core';

@Directive({
  selector: '[emAutoFocus]',
  standalone: true
})
export class AutoFocusDirective implements AfterViewInit {

  constructor(private element: ElementRef<HTMLInputElement>, private cdr: ChangeDetectorRef) { }

  ngAfterViewInit(): void {
    this.element.nativeElement.focus();
    this.element.nativeElement.select();
    this.cdr.detectChanges();
  }
}
